import React from 'react';
import { Container, Spinner } from 'react-bootstrap';

const LoadingPanel = ({ title = 'Loading...', subtitle, spinnerOnly = false }) => {
  if (spinnerOnly) {
    return (
      <div className="text-center p-5">
        <h5>{title}</h5>
        <Spinner animation="border" size="sm" className="mt-2" />
      </div>
    );
  }
  return (
    <Container className="py-5 text-center">
      <div className="glass-container p-5">
        <h4 className="mb-4">{title}</h4>
        <Spinner animation="border" />
        {subtitle && <p className="mt-3 text-muted">{subtitle}</p>}
      </div>
    </Container>
  );
};

export default LoadingPanel;
